import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

/**
 * Initialize review slider blocks.
 *
 * @return {void}
 */
function initializeReviewSliders() {

	document.querySelectorAll( '.b-review-slider' ).forEach( ( block ) => {

		const swiperContainer = block.querySelector( '.b-review-slider__swiper' );

		if ( ! swiperContainer || swiperContainer.swiper ) {

			return;

		}

		new Swiper( swiperContainer, {
			modules: [ Navigation ],
			grabCursor: true,
			slidesPerView: 1,
			spaceBetween: 6,
			navigation: {
				prevEl: block.querySelector( '.js-b-review-slider-prev' ),
				nextEl: block.querySelector( '.js-b-review-slider-next' ),
			},
			breakpoints: {
				768: {
					slidesPerView: 2,
					spaceBetween: 6,
				},
				1280: {
					slidesPerView: 3,
					spaceBetween: 8,
				},
			},
		} );

	} );

}

initializeReviewSliders();
